module.exports = __webpack_public_path__ + "img/promo-bg--579.9fd6f75.jpg";